<template>
	<div class="animated fadeIn">
		<h1 class="text-light">{{$t('map.title')}}</h1>
		<!--<div class="map-container">
			
		</div>-->

		<GmapMap
			ref="mapRef"
			:center="currentPosition"
			:zoom="13"
			map-type-id="roadmap"
			style="width: 100%; height: 80vh"
		>

		<GmapMarker
			:position="currentPosition"
		></GmapMarker>

			<!--<GmapMarker
			:position="{ lat: 24.77404, lng: 121.01735 }"
			:clickable="true"
			:draggable="false"
			/>

			<GmapMarker
			:position="{ lat: 24.77763, lng: 121.03424 }"
			:clickable="true"
			/>-->
	
		</GmapMap>

		<b-modal :title="$t('qrcode_scanning')" v-model="showCameraModal" :ok-title="$t('ok')" :ok-only="true" :hide-footer="true" @hidden="hideScanner()">
		<b-alert :show="showCameraModal" variant="success"><i class="fa fa-exclamation-triangle"></i> {{$t('please_qrcode_scanning')}}</b-alert>
		<!-- <canvas id="qrcode-window" v-if="show_qrcode_canvas"></canvas> -->
		<!-- <video id="qrcode-video" playsinline muted></video> -->
		<video
			v-show="showCameraModal"
			id="qrvideo"
			autoplay
			muted
			loop
			playsinline
			webkit-playsinline
			style="border: 1px solid gray; width: 100%; height: 100%"></video>
		<p class="text-primary">{{qrcode_string}}</p>
		</b-modal>

		<b-modal :title="$t('error_message')" v-model="showErrorModal" :ok-title="$t('ok')" :ok-only="true">
			<b-alert :show="showErrorModal" variant="danger"><i class="fa fa-exclamation-triangle"></i> {{errorMsg}}</b-alert>
		</b-modal>

		<b-modal id="custom-modal" v-model="showLocationInfoModal" :title="locationInfoTitle" :hide-footer="true" :hide-header="false">
			<b-row class="mb-1">
				<b-col cols="12">
					<b-button variant="success" class="top-up-btn-sm" @click="onStartNavigation()">{{$t('map.start_navigation')}}</b-button>
				</b-col>
			</b-row>
			<!--<div class="mb-1">
				<b-button style="margin: 0 3px;font-size:1rem;" class="pull-right" size="sm" variant="success" @click="onStartNavigation()">{{$t('map.start_navigation')}}</b-button>
			</div>-->
			<div class="mb-1">
				<h5 v-if="locationAccessRules == 'RESIDENT'" style="color: red;">{{$t('map.resident_only')}}</h5>
				<h5 v-if="locationAccessRules == 'STAFF'" style="color: red;">{{$t('map.staff_only')}}</h5>
				<h5 v-if="(locationSupportCarBrands.length > 0)" style="color: #c07711;">※{{getSupportCarBrands()}}※</h5>
			</div>
			<div class="mb-1">
				<h5 style="color: #2373E6;">{{locationBillingMethod === 'TIME' ? $t('time-base_billing') : $t('energy-base_billing')}}：</h5>
				<p v-if="locationEnablePeakTime == false" class="mb-0">
					{{locationPrice}}{{locationBillingMethod === 'TIME' ? $t('points_per_minute') : $t('points_per_kwh')}}
					({{$math.round(locationPrice * 115) / 100}}{{locationBillingMethod === 'TIME' ? $t('price_per_minute') : $t('price_per_kwh')}})
					<br><span style="color: #c07711;" v-html="getDiscountPrice(locationPrice)"></span>
				</p>
				<p v-if="locationEnablePeakTime == true" class="mb-0">
					{{$t('map.off_peak')}}：
					{{locationPrice}}{{locationBillingMethod === 'TIME' ? $t('points_per_minute') : $t('points_per_kwh')}}
					({{$math.round(locationPrice * 115) / 100}}{{locationBillingMethod === 'TIME' ? $t('price_per_minute') : $t('price_per_kwh')}})
					<br><span style="color: #c07711;" v-html="getDiscountPrice(locationPrice)"></span>
				</p>
				<p v-if="locationEnablePeakTime == true" class="mb-0">
					{{$t('map.peak')}}：
					{{locationPricePeak}}{{locationBillingMethod === 'TIME' ? $t('points_per_minute') : $t('points_per_kwh')}}
					({{$math.round(locationPricePeak * 115) / 100}}{{locationBillingMethod === 'TIME' ? $t('price_per_minute') : $t('price_per_kwh')}})
					<br><span style="color: #c07711;" v-html="getDiscountPrice(locationPricePeak)"></span>
				</p>
				<div v-if="(locationEnablePeakTime == true) && (locationPeakTimePeriods.length > 0)" class="mb-0">
					<p class="mb-0">{{$t('map.peak_time')}}：</p>
					<p class="mb-0" v-for="(peak_time, index) in locationPeakTimePeriods" :key="peak_time.start_time">
						{{peak_time.start_time + '~' + peak_time.end_time}}
					</p>
				</div>
				<p v-if="locationEnablePeakTime == true" class="mb-0">(<span v-html="HolidayPeakTimeNote"></span>)</p>
				<p v-if="locationEnableIdleFee == false">(1 {{$t('point')}} = 1.15 {{$t('price_unit')}})</p>
				
			</div>

			<div v-if="locationEnableIdleFee == true" class="mb-1">
				<h5 style="color: #2373E6;">{{$t('map.idle_charge')}}：</h5>
				<p class="mb-0">
					{{locationPriceIdle}}{{$t('points')}}/{{locationIdleIntervalRate}}{{$t('minute')}}
					({{$math.round(locationPriceIdle * 115) / 100}}{{$t('price_unit')}}/{{locationIdleIntervalRate}}{{$t('minute')}})
					<br><span style="color: #c07711;" v-html="getDiscountPriceIdle(locationPriceIdle, locationIdleIntervalRate)"></span>
				</p>
				<p class="mb-0">
					({{$t('map.idle_free_info', { idle_free_period: locationIdleFreePeriod })}})
				</p>
				<p>(1 {{$t('point')}} = 1.15 {{$t('price_unit')}})</p>
			</div>
			
			<div class="mt-1 mb-1">
				<h5 style="color: #2373E6;">{{$t('map.description')}}：</h5>
				<p v-html="locationDescription"></p>
			</div>
			
			<div class="mb-1">
				<h5 style="color: #2373E6;">{{$t('map.available_parking_spaces')}}：{{show_devices_list ? locationAvailableDeviceCount : $t('map.private')}}</h5>
				<div v-if="show_devices_list" class="mb-1" style="height: 300px; overflow-x: hidden; overflow-y: auto;">
					<v-server-table
					class="d-none d-md-block d-lg-block d-xl-block"
					:columns="device_columns"
					:data="device_data"
					:options="deviceoptions"
					:theme="theme"
					ref="deviceDataTable"
					id="deviceDataTable">
						<a slot="name" slot-scope="props">{{props.row.name ? props.row.name : $t('unknow')}}</a>
						<a slot="status" slot-scope="props"><span :id="'PCHolder'+props.row.id"><i class="fa fa-question-circle"></i></span></a>
					</v-server-table>

					<!--<b-card v-if="target_devices.length" v-for="(entry, idx) in target_devices" :key="entry.id" :header="`${entry.name}`" 
					class="d-none d-block d-sm-block d-md-none d-lg-none d-xl-none">
						<div class="custom-padding">
							<label class="custom-padding">狀態：</label>
							<span :id="'_PCHolder'+entry.id"><i class="fa fa-question-circle"></i></span>
						</div>
					</b-card>-->
					<b-card no-body v-if="target_devices.length" v-for="(entry, idx) in target_devices" :key="entry.id" class="mb-0 d-none d-block d-sm-block d-md-none d-lg-none d-xl-none">
						<div slot="header">
							<i class="fa fa-cube"></i> {{entry.name}}&nbsp;
							<span class="pull-right" :id="'_PCHolder'+entry.id"><i class="fa fa-question-circle"></i></span>
					  	</div>
					</b-card>
				</div>
			</div>

			<div class="mt-2">
				<h5 style="color: #2373E6;">{{$t('map.address')}}：</h5>
				<p>{{locationAddress}}</p>
			</div>
		</b-modal>
	</div>
</template>
<script>
import Vue from 'vue'
import config from '@/config/global'
import notifications from '@/config/notifications'
import {ServerTable, Event} from 'vue-tables-2'
import jQuery from 'jquery'
import moment from 'moment-timezone'
import * as VueGoogleMaps from 'vue2-google-maps'

import { BrowserQRCodeReader } from '@zxing/library';

Vue.use(ServerTable)

Vue.use(VueGoogleMaps, {
  load: {
    key: config.google_maps_api_key,
    libraries: 'places', // 需要的话可以添加更多的库
  },
  installComponents: true
})

const codeReader = new BrowserQRCodeReader();

let eventbus = config.eventbus;
let scanner  = null;

let getUrlParameter = function getUrlParameter(url) {
  let sPageURL = url.substring(url.indexOf('?')+1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i,
      rlt={};

  for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');
      rlt[sParameterName[0]] = sParameterName[1];
  }

  return rlt;
};//eo getUrlParameter

let user_id_token_check = function(app){   
  let user = app.$state.$get('user');

  if(!user) {
    //console.info(`user_id_token_check no user`);
    return;
  }
  //console.info(`user_id_token_check user.uuid: ${user.uuid}`);

  let action = `${config.mqtt_root}/user_id_token_check`;
  fetch(action, {
    method: 'POST',
    headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + app.$state.$get('user').token
    },
    body: JSON.stringify({
    user_id: user.uuid
    })
  }).then(res => res.json()).then(result => {
    if(result.success === false){  
      //console.info(`user_id_token_check fail`); 
      app.showError({
        title: app.$t('user_check_error_title'),
        message: app.$t('user_check_error_message')
      });
      app.$state.$del('user');
      app.$router.push('/');
    }
  }).catch(error => {
    app.showError({
      title: app.$t('user_check_error_title'),
      message: app.$t('user_check_error_message')
    });
    app.$state.$del('user');
    app.$router.push('/');
  });
};

function GetMarkerList(app) {
	return new Promise((resolve, reject) => {
		let user = app.$state.$get('user');
		app.geo_locations = [];
		app.user_car_members = [];
		app.user_members = [];

		if(!user) {//ignore check
			resolve();
		} else {
			let action = `${config.mqtt_root}/get_geo_locations`;
			fetch(action, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': 'Bearer ' + app.$state.$get('user').token
				},
				body: JSON.stringify({
					user_id: user.uuid,
					keyset: 'mqtt',
				})
			}).then(res => res.json()).then(result => {
				//console.info('result:', result);
				if(result.success === true){  
					app.geo_locations = result.geo_locations;
					if(result.car_member) {
						app.user_car_members = result.car_member.car_members;
					} 
					if(result.member) {
						app.user_members = result.member.members;
					} 
				}
				resolve();
			}).catch(error => {
				resolve();
			});
		}
	});
};

let status_update = function(app) {
	//console.info('app.devices_ids:', app.devices_ids);
	if(app && app.devices_ids.length){
		let skip = {};
		let action = `${config.mqtt_root}/get_latest_charging_record`;
		fetch(action, {
			method: 'POST',
			headers: {
			'Content-Type': 'application/json',
			'Authorization': 'Bearer ' + app.$state.$get('user').token
			},
			body: JSON.stringify({
				user_id:  1,
				device_ids: app.devices_ids,
				keyset: 'mqtt',
			})
		}).then(res => res.json()).then(charging_records => {
			//console.info('charging_records:', charging_records);
			app.locationAvailableDeviceCount = 0;

			app.target_devices.forEach((device) => {
				//console.info('device:', device);
				if(device.device_activated) {
					let is_open_time = true;
					let status = `<span class="text-success">${app.$t('map.standby')}</span>`;
					if(charging_records && charging_records.open_status) {
						let open_status = charging_records.open_status.find(item => item.id === device.id);
						if(open_status !== undefined) {
							is_open_time = open_status.is_open_time;
						}
					}
					if(!is_open_time) {
						status = `<span class="text-danger">${app.$t('map.not_open')}</span>`;
					} else {
						app.locationAvailableDeviceCount++;
					}

					if(charging_records.success){
						let charging_record = charging_records.records.find(item => item.device_uid === device.id);
						if(charging_record !== undefined) {
							//console.info('found charging_record:', charging_record);

							if(charging_record.end_time && charging_record.end_time>charging_record.start_time){
								if(is_open_time) {
									status = `<span class="text-success">${app.$t('map.standby')}</span>`;
								}
							} else if(charging_record.stop_time){
								status = `<span class="text-warning">${app.$t('map.idling')}</span>`;
								if(is_open_time) {
									app.locationAvailableDeviceCount--;
								}
							} else if(charging_record.start_time) {
								status = `<span class="text-primary">${app.$t('map.charging')}</span>`;
								if(is_open_time) {
									app.locationAvailableDeviceCount--;
								}
							}
						}
					}
					jQuery('#PCHolder' + device.id).html(status);
					jQuery('#_PCHolder' + device.id).html(status);
				}
			});
		}).catch(error => {
		});
	}
};

export default {
	name: 'Maps',
	notifications,
	computed: {
		HolidayPeakTimeNote() {
			const link = `<a href="https://www.google.com/search?q=%E6%99%82%E9%96%93%E9%9B%BB%E5%83%B9%E6%97%A5%E6%9B%86%E8%A1%A8" target="_blank">${this.$t('time_of_use_calendar')}</a>`;
			return this.$t('holiday_peak_time_note_message', { link });
		}
	},
	data(){
		let $tz = moment().tz(config.timezone);
    	let root = this;
		return {
			theme: '',
			start_time:'',
			end_time:'',
			showErrorModal: false,
			showCameraModal: false,
			qrcode_string: '',
			errorMsg:'',
			user_car_members: [],
			user_members: [],
			locationSupportCarBrands:[],
			locationInfoTitle: this.$t('unknow'),
			locationLat: 0.0,
			locationLng: 0.0,
			locationAddress: this.$t('unknow'),
			locationDescription: this.$t('none'),
			locationAccessRules:'EVERYONE',
			locationEnablePeakTime: false,
			locationPeakTimePeriods: [],
			locationBillingMethod:'KWH',
			locationPrice:0,
			locationPricePeak:0,
			locationPriceIdle:0,
			locationIdleFreePeriod:0,
			locationIdleIntervalRate:0,
			locationIdleMaxPrice:0,
			locationAvailableDeviceCount: 0,
			locationEnableIdleFee: false,
			showLocationInfoModal: false,
			show_devices_list: true,
			target_geo_location: '',
			target_devices: [],
			target_devices_count: 0,
			target_devices_total_page: 1,
			target_devices_current_page: 1,
			target_devices_limit: 25,
			device_data: [],
      		cameraDevices: [],
			geo_locations: [],
			devices_ids: [],
			retry_count: 0,
			currentPosition: { lat: 24.147680, lng: 120.673509 }, //台中市
			blue_charger_icon_url: 'https://mt.googleapis.com/vt/icon/name=icons/onion/SHARED-mymaps-container-bg_4x.png,icons/onion/SHARED-mymaps-container_4x.png,icons/onion/1787-ev-station_4x.png&highlight=ff000000,0288D1&scale=1.2',
			green_charger_icon_url: 'https://mt.googleapis.com/vt/icon/name=icons/onion/SHARED-mymaps-container-bg_4x.png,icons/onion/SHARED-mymaps-container_4x.png,icons/onion/1787-ev-station_4x.png&highlight=ff000000,7CB342&scale=1.2',
			device_columns: ['name', 'status'],
			deviceoptions: {
				headings: {
					name: this.$t('map.deviceoptions.name'),
  					status: this.$t('map.deviceoptions.status'),
				},
				orderBy: {
					column: 'name',
					ascending: false
				},
				sortable: ['name', 'status'],
				filterable: [],
				sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
				pagination: {
					chunk: 5,
					edge: false,
					nav: 'scroll'
				},
				perPage: 2000,
				perPageValues:[],
				texts: {
					count: '',
				},
				requestFunction(data) {
					let app = this;
					//console.log(`root.target_geo_location: `, root.target_geo_location);
					if(root.target_geo_location == '') {
						root.target_geo_location = ' ';
					} 

					let target_geo_location = encodeURIComponent(config.encrypt(root.target_geo_location, config.ffkey, config.ffiv));
					//console.log(`target_geo_location: `, target_geo_location);
					let action = `${config.mqtt_root}/get_devices`;
					let params = {
						keyset: 'mqtt',
						geo_location: target_geo_location,
					};

					let ccff = this.$state.$get('ccff');
					if(ccff){
						params['ccff'] = ccff;
					}

					for(let col in data){
						params[col] = data[col];
					}

					return fetch(action, {
						method: 'POST',
						headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + app.$state.$get('user').token
						},
						body: JSON.stringify(params)
					}).then(res => res.json()).then(result => {
						root.target_devices = result.data || [];
						root.target_devices_count = result.count || 0;
						root.target_devices_current_page = params.page;
						root.target_devices_limit = params.limit;
						if (root.target_devices_count) {
							root.target_devices_total_page = Math.ceil(root.target_devices_count / params.limit);
						}
						//console.info('root.target_devices: ', root.target_devices);
						return {
						data: result.data || [],
						count: result.count || 0
						};
					}).catch(error => {
						return {
						data: [],
						count: 0
						};
					});
				}//eo requestFunction
			},
		}
	},//eo data
	created() {
		let app = this;
		
		app.$on('qrcodeDetected', function(result){
			//console.info('qr result:', result);
			
			app.$emit('reveived-qrcode', result);
			app.show_qrcode_canvas = false; 
			app.showCameraModal    = false;

			let params = getUrlParameter(result);
					
			if(params && params.uuid){
				app.uuid = decodeURIComponent(params.uuid);
				app.$state.$set('uuid', app.uuid);
				
				//Attention!! JQuery.param will add encodeURIComponent() for params automatically. So "DO NOT" add by yourself(Avoid double encode issue).
				let href = location.origin + '/#/dashboard/showdevice?' + jQuery.param({
				uuid: app.uuid
				});

				// console.info('href:', href);

				window.location = href;

				location.reload();
			}
		});
	},
	mounted() {
		let app   = this;
		let user  = this.$state.$get('user');
		let token = user ? this.$state.$get('user').token : null;
		let position = this.$state.$get('currentPosition');
		this.showLocationInfoModal = false;
		this.currentPosition = position !== null ? position :  { lat: 24.147680, lng: 120.673509 };

    	//console.info(token);
		if(!user) {
			app.showError({message:app.$t('please_login')});
            let _vcc = setTimeout(() => {
              app.$router.push('/');
              clearTimeout(_vcc);
            }, 1500);
			return;
		}

		//Added force logout to avoid user.user_id encrypt with wrong iv/key when backend server restarting.
		user_id_token_check(app);

		if(!token){
			this.$state.$set('error', config.error.INVALID_USER);
	    	this.$router.push('/');
	    	return;
		}

		eventbus.$on('start-qrcode-scanning', this.openQrCodeScanner);

		this.handler = function(records) {
			// console.info('vue-tables.loaded:', records);
			app.devices_ids = [];
			if(records) {
				records.data.forEach((record, idx) => {
					if(record.id){
						app.devices_ids.push(record.id);

						//check connection status
						if(record.device_activated !== true) {
							jQuery('#PCHolder' + record.id).html(`<span class="text-danger">${app.$t('map.offline')}</span>`);
							jQuery('#_PCHolder' + record.id).html(`<span class="text-danger">${app.$t('map.offline')}</span>`);
						}

						//process support car brands
						if(record.support_car_brand) {
							let support_car_brands = record.support_car_brand.split('/');
							support_car_brands.forEach((car_brand, idx) => {
								if(app.locationSupportCarBrands.find(item => item === car_brand) === undefined){
									app.locationSupportCarBrands.push(car_brand);
								}
							});
						}

						if(record.demo == 'YES') { //demo device is free.
							app.locationPrice = 0;
							app.locationPricePeak = 0;
							app.locationPriceIdle = 0;
						}

						if(record.idle_fee) {
							app.locationEnableIdleFee = true;
						}
					}
				});
				//console.info('vue-tables.loaded:', app.devices_ids);
				//console.info('app.locationSupportCarBrands:', app.locationSupportCarBrands);
				status_update(app, app.devices_ids);
			}
		};
		Event.$on('vue-tables.loaded', this.handler);

		this.getUserLocation();

		GetMarkerList(app).then(()=>{
			//console.info('GetMarkerList done');
			
			this.$refs.mapRef.$mapPromise.then((map) => {
				class CustomTextOverlay extends google.maps.OverlayView {
					position;
					content;
					div;
					constructor(position, content) {
						super();
						this.position = position;
						this.content = content;
						this.div = null;
					}

					onAdd() {
						this.div = document.createElement('div');
						this.div.style.position = 'absolute';
						//this.div.style.position = 'relative';
						this.div.innerHTML = `<div class="text-with-outline">${this.content}</div>`;
						this.div.style.transform = "translate(-50%, 0%)";//文字居中顯示

						const panes = this.getPanes();
						panes.overlayLayer.appendChild(this.div);
					}

					draw() {
						const overlayProjection = this.getProjection();
						const position = overlayProjection.fromLatLngToDivPixel(this.position);

						this.div.style.left = `${position.x}px`;
						this.div.style.top = `${position.y}px`;
					}

					onRemove() {
						if (this.div) {
						this.div.parentNode.removeChild(this.div);
						this.div = null;
						}
					}
					/**
					 *  Set the visibility to 'hidden' or 'visible'.
					 */
					hide() {
						if (this.div) {
							this.div.style.visibility = "hidden";
						}
					}
					show() {
						if (this.div) {
							this.div.style.visibility = "visible";
						}
					}
					toggle() {
						if (this.div) {
							if (this.div.style.visibility === "hidden") {
								this.show();
							} else {
								this.hide();
							}
						}
					}
					toggleDOM(map) {
						if (this.getMap()) {
							this.setMap(null);
						} else {
							this.setMap(map);
						}
					}
				}

				app.geo_locations.forEach((geo_location, index) => {
					//console.info(`[${index}] ${geo_location.geo_location}, ${geo_location.lat}, ${geo_location.lng}`);  
					let lat = parseFloat(geo_location.lat);
					let lng = parseFloat(geo_location.lng);

					if(!isNaN(lat) && !isNaN(lng)) {
						let icon_url = this.blue_charger_icon_url;
						let position = new google.maps.LatLng(lat, lng);
						if(geo_location.access_rules == 'EVERYONE') {
							let content = geo_location.name;
							let customTextOverlay = new CustomTextOverlay(position, content);
							customTextOverlay.setMap(map);
						} else {
							icon_url = this.green_charger_icon_url;
						}
						
						const marker = new google.maps.Marker({
							position: position,
							icon: {
								url: icon_url,
							},
						});
						marker.addListener('click', () => {
							this.popLocationInfoModal(geo_location);
						});
						marker.setMap(map);
					}
				});
			});
		});
	},//eo mounted
	beforeDestroy() {
		Event.$off('vue-tables.loaded', this.handler);
	},

	watch: {
		'$i18n.locale'() {
			//console.info('watch $i18n.locale');
			this.$nextTick(() => {
				this.updateTableOptions();
			});
		},
	},

	methods: {
		openQrCodeScanner() {
			let app = this;

			app.showCameraModal       = true
			app.show_scan_qrcode_msg = true;
			app.show_qrcode_canvas   = true;

			// let _ccc = setTimeout(() => {
			//  clearTimeout(_ccc);
			//  init_qrcode_reader(app);
			// }, 1000);

			codeReader
			.listVideoInputDevices()
			.then((videoInputDevices) => {
				let targetCamera;
				videoInputDevices.forEach((device) => {
				this.cameraDevices.push(`${device.label}, ${device.deviceId}`);
				if (this.camera === 'front' && device.label.toLowerCase().indexOf('front') !== -1) {
					targetCamera = device.deviceId;
					return false;
				}
				return true;
				});
				codeReader
				.decodeFromInputVideoDevice(undefined, 'qrvideo')
				.then(result => this.onDecode(result.text))
				.catch(err => {
				// this.showError({message:this.$t('qr_code_detect_error')});
				console.error(err)
				});
			})
			.catch(err => { 
				this.showError({message:this.$t('qr_code_detect_error')});
				console.error(err)
			});

		},//eo openQrCodeScanner
		onDecode(data) {
			this.$emit('qrcodeDetected', data);
			this.showSuccess({message:this.$t('qr_code_detected')});
		},
		hideScanner(){
			// let app = this;
			// app.getVideo().stop();
			if(scanner !== null && scanner.destroy){
				scanner.destroy();
				scanner = null;
			}
		},//eo hideScanner
		gotoPage(page) {
			// console.info('new page: ', page);
			this.$refs.deviceDataTable.setPage(page);
		},
		onStartNavigation(){
			//https://www.google.com/maps/dir//24.4691788,120.968394
			if(this.locationLat != 0.0 && this.locationLng != 0.0) {
				let target_url = `https://www.google.com/maps/dir//${this.locationLat},${this.locationLng}`;
				//console.log(`target_url: `, target_url);
				window.open(target_url, '_blank');
			} else {
				this.showError({
					title: this.$t('map.error.navigation_error_title'),
					message: this.$t('map.error.navigation_error_message')
				});
			}
		},
		getDiscountPrice(price){
			let app = this;
			let result = '';
			//console.info(`price = ${price}`);
			let value = parseFloat(price);
			//console.info('value:', value);
			if(!isNaN(value)) {
				let discount = 1.0;
				//console.info('user_car_members:', this.user_car_members);
				//console.info('locationSupportCarBrands:', this.locationSupportCarBrands);
				if(this.user_car_members && this.user_car_members.length) {
					this.user_car_members.forEach(function(car_member, idx){
						if(app.locationSupportCarBrands && app.locationSupportCarBrands.find(item => item === car_member.car_brand) ){
							//console.info('car_brand: ', car_member.car_brand, ', Discount:', car_member.discount);
							discount = car_member.discount;

							//console.info('Discount:', discount);
							if(discount != 1.0) {
								if(result.length == 0) {
									result = car_member.car_brand;
								} else {
									result += `<br>` + car_member.car_brand;
								}

								result += `${app.$t('map.discount_price')} `;

								let point_value = app.$math.round(value * discount, 2);
								result += point_value;
								result += app.locationBillingMethod === 'TIME' ? app.$t('points_per_minute') : app.$t('points_per_kwh');
								
								let price_value = app.$math.round(value * discount * 115) / 100;
								result += '(';
								result += price_value;
								result += app.locationBillingMethod === 'TIME' ? app.$t('price_per_minute') : app.$t('price_per_kwh');
								result += ')';
							}
						}
					});
				}
			}
			return result;
		},
		getDiscountPriceIdle(price, rate){
			let app = this;
			let result = '';
			//console.info(`price = ${price}`);
			let value = parseFloat(price);
			//console.info('value:', value);
			if(!isNaN(value)) {
				let discount = 1.0;
				//console.info('user_car_members:', this.user_car_members);
				//console.info('locationSupportCarBrands:', this.locationSupportCarBrands);
				if(this.user_car_members && this.user_car_members.length) {
					this.user_car_members.forEach(function(car_member, idx){
						if(app.locationSupportCarBrands && app.locationSupportCarBrands.find(item => item === car_member.car_brand) ){
							//console.info('car_brand: ', car_member.car_brand, ', Discount:', car_member.discount);
							discount = car_member.discount;

							//console.info('Discount:', discount);
							if(discount != 1.0) {
								if(result.length == 0) {
									result = car_member.car_brand;
								} else {
									result += `<br>` + car_member.car_brand;
								}
								
								result += `${app.$t('map.discount_price')} `;

								let point_value = app.$math.round(value * discount, 2);
								result += point_value + `${app.$t('points')}/` + rate + `${app.$t('minute')}`;
								
								let price_value = app.$math.round(value * discount * 115) / 100;
								result += '(';
								result += price_value + `${app.$t('points')}/` + rate + `${app.$t('minute')}`;
								result += ')';
							}
						}
					});
				}
			}
			return result;
		},
		getSupportCarBrands(){
			let result = this.$t('map.eligible_for') + ' ';
			this.locationSupportCarBrands.forEach((car_brand, idx) => {
				if(idx == 0) {
					result += car_brand;
				} else {
					result += '、' + car_brand;
				}
			});
			result += ' ' + this.$t('map.discount_price2');
			return result;
		},
		getUserLocation() {
			if (navigator.geolocation) {
				let msg = '';
				navigator.geolocation.getCurrentPosition(
					(position) => {
						this.currentPosition = {
							lat: position.coords.latitude,
							lng: position.coords.longitude,
						};
						this.$state.$set('currentPosition', this.currentPosition);
					},
					(error) => {
						console.error("Error getting user's location:", error);
						msg = `${this.$t('map.error.location_access_error')}: ` + error.message; //TODO: i18n
						if (window.confirm(msg)) {
						}
					}
				);
			} else {
				console.error("Geolocation is not supported by this browser.");
			}
		},//eo getUserLocation
		refreshTable(){ //Add to fixed sometime get refresh not define error.
			//console.info("retry_count:", this.retry_count);
			if(this.show_devices_list) {
				if(this.retry_count < 10) {
					if(this.$refs.deviceDataTable) {
						this.$refs.deviceDataTable.refresh();
					} else {
						this.$nextTick(() => {
							this.retry_count++;
							this.refreshTable();
						});
					}
				} else {
					this.showError({
					message: 'Table refresh error',
					}); 
				}
			}
		},
		popLocationInfoModal(geo_location) {
			this.locationSupportCarBrands = [];
			this.target_geo_location = '';
			this.locationInfoTitle = this.$t('unknow');
			this.locationLat = 0.0;
			this.locationLng = 0.0;
			this.locationAddress = this.$t('unknow');
			this.locationDescription = this.$t('none');
			this.locationAccessRules = 'EVERYONE';
			this.locationEnablePeakTime = false;
			this.locationPeakTimePeriods = [];
			this.locationBillingMethod = 'KWH';
			this.locationPrice = 0;
			this.locationEnableIdleFee = false;
			this.locationPricePeak = 0;
			this.locationPriceIdle = 0;
			this.locationIdleFreePeriod = 0;
			this.locationIdleIntervalRate = 0;
			this.locationAvailableDeviceCount = 0;
			this.show_devices_list = false;
			if(geo_location) {
				//console.log(`geo_location: `, geo_location);
				this.target_geo_location = geo_location.name;

				if(geo_location.access_rules == 'EVERYONE') {
					this.show_devices_list = true;
				}

				if(geo_location.sub_name.length > 0) {
					this.locationInfoTitle = `${geo_location.name}(${geo_location.sub_name})`;
				} else {
					this.locationInfoTitle = `${geo_location.name}`;
				}

				let lat = parseFloat(geo_location.lat);
				if(!isNaN(lat)) {
					this.locationLat = geo_location.lat;
				}
				
				let lng = parseFloat(geo_location.lng);
				if(!isNaN(lng)) {
					this.locationLng = geo_location.lng;
				}
				
				this.locationAddress = geo_location.address.length > 0 ? geo_location.address : this.$t('unknow');
				this.locationDescription = geo_location.description.length > 0 ? geo_location.description : this.$t('none');
				this.locationAccessRules = geo_location.access_rules;
				this.locationEnablePeakTime = geo_location.enable_peak_time ? true : false;
				this.locationPeakTimePeriods = geo_location.peak_time_periods ? geo_location.peak_time_periods : [];
				this.locationBillingMethod = geo_location.billing_method ? geo_location.billing_method : 'KWH';
				this.locationPrice = geo_location.price ? geo_location.price : 0;
				this.locationPricePeak = geo_location.price_peak ? geo_location.price_peak : 0;
				this.locationPriceIdle = geo_location.price_idle ? geo_location.price_idle : 0;
				let idle_info = geo_location.idle_info ? geo_location.idle_info : '0/0';
				let [idle_free_period, idle_interval_rate, idle_max_price] = idle_info.split('/');
				this.locationIdleFreePeriod = parseInt(idle_free_period); //min
				this.locationIdleIntervalRate = parseInt(idle_interval_rate); //min
				this.locationIdleMaxPrice = parseFloat(idle_max_price); //points
				this.showLocationInfoModal = true;

				if(this.show_devices_list) {
					this.$nextTick(() => {
						this.retry_count = 0;
						this.refreshTable();
					});
				}
			} else {
				console.log(`geo_location not found`);
			}
		}, // eo popLocationInfoModal
		updateTableOptions() {
			this.deviceoptions.headings.name = this.$t('map.deviceoptions.name');
			this.deviceoptions.headings.status = this.$t('map.deviceoptions.status');
			this.$forceUpdate();
		},
	},//eo methods
}
</script>

<style lang="scss">
#dataTable {
	width: 95%;
	margin: 0 auto;
	margin-top: 0.5rem;
	font-size: 0.75rem;

	.VuePagination {
	  text-align: center;
	  justify-content: center;
	}

	.vue-title {
	  text-align: center ;
	  margin-bottom: 10px;
	}

	.VueTables__search-field {
	  display: flex;
	}
	.VueTables__search-field input {
	  margin-left: 0.25rem;
	}

	.VueTables__limit-field {
	  display: flex;
	}

	.VueTables__limit-field select {
	  margin-left: 0.25rem !important;
	}

	.VueTables__table th {
	  text-align: center;
	}

	.VueTables__child-row-toggler {
	  width: 16px;
	  height: 16px;
	  line-height: 16px;
	  display: block;
	  margin: auto;
	  text-align: center;
	}

	.VueTables__child-row-toggler--closed::before {
	  content: "+";
	}

	.VueTables__child-row-toggler--open::before {
	  content: "-";
	}

	.VueTables__sortable {
		padding: 0.25rem;
	}
}
#custom-modal .modal-dialog {
    max-height: 90vh !important;
	display: flex;
	justify-content: center;
  	align-items: center;
}
#custom-modal .modal-content {
	max-height: 90vh !important;
    overflow-y: auto;
}
.modal .modal-xl {
	width: 90% !important;
	max-width: 90% !important;
}
.newline {
	display: block;
}
.breadcrumb{display: none;}
.pt-3, .py-3 { padding-top: 0.35rem !important; }
.VueTables__search-field label, .VueTables__limit-field label{
	display: none;
	width: 0px;
}
.VueTables__pagination{
	display: none;
}
.map-container {
min-height: 300px;
max-height: 800px;
display: flex;
}
.custom-padding {
padding: 0px;
}
.top-up-btn{
height: 5rem;
max-width: 98%;
min-width: 98%;
font-size: 2rem;
margin: 0.5px 0px;
}
.top-up-btn-sm{
height: 3rem;
max-width: 100%;
min-width: 100%;
font-size: 1.5rem;
}
.text-with-outline {
color: blue; /* text color */
font-size: 16px; /* text size */
font-weight: bold;
/* text stroke */
text-shadow: 
	-1px -1px 0 #FFF,  
	1px -1px 0 #FFF,
	-1px 1px 0 #FFF,
	1px 1px 0 #FFF;
}

</style>
